import { create } from "zustand";

interface PDFViewerState {
  pdfUrl: string;
  documentName: string;
  isVisible: boolean;
  setPdfUrl: (url: string) => void;
  setDocumentName: (name: string) => void;
  setVisible: (visible: boolean) => void;
  viewDocument: (url: string, documentName?: string) => void;
  closeViewer: () => void;
}

export const usePDFViewerStore = create<PDFViewerState>((set) => ({
  pdfUrl: "",
  documentName: "",
  isVisible: false,

  setPdfUrl: (url) => set({ pdfUrl: url }),
  setDocumentName: (name) => set({ documentName: name }),
  setVisible: (visible) => set({ isVisible: visible }),

  viewDocument: (url, documentName = "") =>
    set({
      pdfUrl: url,
      documentName,
      isVisible: true,
    }),

  closeViewer: () =>
    set({
      pdfUrl: "",
      documentName: "",
      isVisible: false,
    }),
}));
